import { type MouseEvent, type FC } from 'react'
import { Button } from 'shared/ui'
import { type Contact } from 'entities/Contacts/model/Contact'
import { type IParamsContactsOptOut } from 'entities/Contacts/api/types'
import { successOpIinHandler } from 'entities/Contacts/lib/successOpIinHandler'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { ContactsOptInModalStore } from 'widgets/ContactsOptInModal'
import { useConversationListContext } from 'pages/conversations/ui/ConversationList/context'

type IButtonOptInStatusProps = {
  contactsIds: number[]
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  clickCallback?: () => void
}

export const ButtonOptInStatus: FC<IButtonOptInStatusProps> = ({
  contactsIds,
  onMouseEnter,
  onMouseLeave,
  clickCallback,
}) => {
  const entities = useEntitiesContext()
  const { contactsStore } = entities
  const store = useConversationListContext()
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation()

    const contacts = contactsIds.reduce<Contact[]>((state, id) => {
      const item = contactsStore.getItem(id)

      return item ? [...state, item] : state
    }, [])

    const successHandler = (opt_outs: IParamsContactsOptOut['opt_outs']) => {
      contacts.forEach((contact) => {
        successOpIinHandler(contact, opt_outs)
      })
    }

    new ContactsOptInModalStore(entities).handleOpen(contacts, {
      reset: () => {
        store.handleResetSelect()
      },
      successHandler,
      isBulkAll: false,
    })

    clickCallback?.()
  }

  return (
    <Button
      fontWeight={400}
      onClick={handleClick}
      typeBtn='menuItem'
      icon={'toggle'}
      text={'Opt-in status'}
      fullWidth
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    />
  )
}
